module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJ1aS1iZ19nbGFzc181NV9mYmY5ZWVfMXg0MDAucG5nP2Y4ZjQ1NThlMGI5MmZmMmNkNjEzNjc4MTUzMzkwMmVjIjs="


//////////////////
// WEBPACK FOOTER
// ./portal/css/kiss/images/ui-bg_glass_55_fbf9ee_1x400.png
// module id = 304
// module chunks = 9